<template>
  <div class="activity-wrap">
    <app-header />
    <div class="junActivity2">
      <div class="header">
        <div class="w933">
          <p style="padding-top: 50px;">
            <img
              src="../../assets/images/activity/junActivity2/01.png"
              alt=""
              class="title"
            />
          </p>

          <div class="discount_coupon">
            <div class="left">
              <img
                src="../../assets/images/activity/junActivity2/03.png"
                alt=""
              />

              <img
                src="../../assets/images/activity/junActivity2/06.png"
                alt=""
                class="button"
                @click="handleClick365"
              />
            </div>

            <div class="right">
              <img
                src="../../assets/images/activity/junActivity2/04.png"
                alt=""
              />

              <img
                src="../../assets/images/activity/junActivity2/06s.png"
                alt=""
                class="button"
                @click="handleClick1820"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="content01">
        <div class="w933">
          <div class="bg">
            <img
              src="../../assets/images/activity/junActivity2/09.png"
              alt=""
              class="ljqg"
              @click="handleClick365"
            />

            <p class="agreement">
              已经阅读并同意
              <a href="#" style="color:#ffed88"><router-link to="/protocol" target="_blank" style="color: #ffed88;">《使用软件产品许可协议》</router-link></a>
            </p>

            <div class="carousel1">
              <div class="br">
                <el-carousel
                  :interval="3000"
                  arrow="always"
                  height="609px"
                  @mouseenter="isAutoplay1 = false"
                  @mouseleave="isAutoplay1 = true"
                  :autoplay="isAutoplay1"
                >
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/junActivity2/1_01.png"
                      alt=""
                    />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/junActivity2/1_02.png"
                      alt=""
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content03">
        <div class="w933">
          <div class="bg"></div>
        </div>
      </div>

      <div class="content04">
        <div class="w933">
          <div class="bg">
            <img
              src="../../assets/images/activity/junActivity2/09.png"
              alt=""
              class="ljqg"
              @click="handleClick1820"
            />

            <p class="agreement">
              已经阅读并同意
              <a href="#" style="color:#ffed88"><router-link to="/protocol" target="_blank" style="color: #ffed88;">《使用软件产品许可协议》</router-link></a>
            </p>

            <div class="carousel1">
              <div class="br">
                <el-carousel
                  :interval="3000"
                  arrow="always"
                  height="739px"
                  @mouseenter="isAutoplay2 = false"
                  @mouseleave="isAutoplay2 = true"
                  :autoplay="isAutoplay2"
                >
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/junActivity2/2_01.png"
                      alt=""
                    />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/junActivity2/2_02.png"
                      alt=""
                    />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/junActivity2/2_03.png"
                      alt=""
                    />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/junActivity2/2_04.png"
                      alt=""
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content05">
        <div class="w933">
          <div class="bg"></div>
        </div>
      </div>

      <div class="risk_warning">
        风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋<br />
        势；所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险。
      </div>
    </div>

    <div class="shade_bg" v-if="shadeBg">
      <!-- 支付成功 -->
      <img
        src="../../assets/images/activity/junActivity2/17.png"
        class="accomplish"
        alt=""
        v-if="accomplish"
        @click="
          shadeBg = false;
          accomplish = false;
        "
      />

      <!-- 订单生成 -->
      <div class="order_bg" v-if="order">
        <div class="con">
          <p>订单已生成，还差一步</p>
          <p>
            即可开通大智慧 <i v-if="zdhType == '1年大智慧365'">365</i
            ><i v-else>「专业版」</i>
          </p>
          <p>确定放弃购买吗？</p>

          <div class="pay_btn">
            <button
              class="close"
              @click="
                shadeBg = false;
                order = false;
              "
            >
              忍痛放弃
            </button>
            <button class="goon" @click="handleClickgoon">继续支付</button>
          </div>
        </div>
      </div>

      <!-- 支付 -->
      <div class="pay_bg" v-if="pay">
        <div class="top_con">
          <img
            src="../../assets/images/activity/junActivity2/23.png"
            alt=""
            class="close"
            @click="handlePayClickClose"
          />
          <p class="title">
            <span>购买产品:</span>
            <span class="type">{{ zdhType }}</span>
          </p>

          <p class="code">
            <qriously :value="qrData" :size="260" level="M"  v-show="qrData"/>
          </p>

          <ul class="pay_list">
            <li
              v-for="(item, index) in payList"
              :key="index"
              :class="handlePayClickIndex == index ? 'payClick' : ''"
              @click="changeMode(item.payMode,index)"
            >
              <div>
                <p>
                  <img :src="item.img" alt="" />
                </p>

                <p>
                  {{ item.name }}
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div class="btm_con">
          <p class="p1" v-if="zdhType == '1年大智慧365'">
            <span class="span1">支付金额:</span>
            <span class="span2">¥ <i class="span3">678</i></span>
            <span class="span4">¥998</span>

            <span class="span5">已减320元</span>
          </p>

          <p class="p1" v-else>
            <span class="span1">支付金额:</span>
            <span class="span2">¥ <i class="span3">1820</i></span>
            <span class="span4">¥2680</span>

            <span class="span5">已减860元</span>
          </p>

          <p class="p2">
            已经阅读并同意<router-link to="/protocol" target="_blank">《使用软件产品许可协议》</router-link>
          </p>

          <p class="p3">
            发票信息：电子普通发票 
            <span v-if="this.invoiceTitleType == 1">个人</span>
            <span v-else>单位</span>
            信息技术服务 <a @click="openInvoice">发票填开></a>
          </p>
        </div>
      </div>
      <!-- 电子发票组件 -->
      <invoice @saveInvoiceTitleType="changeInvoiceTitleType" ref="invoice" />
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import Invoice from "@/components/invoice/Invoice.vue";
export default {
  components: {
    AppHeader,
    Invoice
  },
  data() {
    return {
      token: "",
      navIndex: 0,
      shadeBg: false,
      accomplish: false,
      order: false,
      pay: false,
      zdhType: "1年大智慧365",
      payList: [
        {
          img: require("../../assets/images/activity/junActivity2/20.png"),
          name: "微信支付",
          payMode: 23
        },
        {
          img: require("../../assets/images/activity/junActivity2/21.png"),
          name: "支付宝",
          payMode: 29
        },
        {
          img: require("../../assets/images/activity/junActivity2/22.png"),
          name: "其他支付",
          payMode: 0
        }
      ],
      handlePayClickIndex: 0,
      isAutoplay1: true,
      isAutoplay2: true,
      s: this.$route.query.s,
      selectedOrderId: '',
      selectedPid: '',
      qrData: '',
      payMode: '23',
      orderId116: '',
      aliPayQrCode116: '',
      wechatPayQrCode116: '',

      orderId73: '',
      aliPayQrCode73: '',
      wechatPayQrCode73: '',
      invoiceTitleType: 1,
      lastInvoiceTitleType: 1,
      timer: '',
      paid116: false,
      paid73: false
    };
  },
  watch: {
    shadeBg(newValue) {
      if (newValue) {
        document.body.style.overflow = "hidden";
      } else {
        if(this.timer && this.timer != ''){
          clearInterval(this.timer);
        }
        document.body.style.overflow = "";
      }
    }
  },
  created() {
    if(!this.s){
      this.s = "";
    }
  },
  mounted() {},
  beforeDestroy() {
    if(this.timer && this.timer != ''){
      clearInterval(this.timer);
    }
    document.body.style.overflow = "";
  },
  methods: {
    handlePayClickClose: function() {
      this.pay = false;
      this.order = true;
    },

    handleClickgoon: function() {
      this.pay = true;
    },

    handleClick365: function() {
      this.zdhType = "1年大智慧365";
      this.shadeBg = true;
      this.pay = true;
      this.saveOrder('116');
    },
    handleClick1820: function() {
      this.zdhType = "1年大智慧专业版";
      this.shadeBg = true;
      this.pay = true;
      this.saveOrder('73');
    },
    changeMode(payMode,index) {
      this.handlePayClickIndex = index;
      this.payMode = payMode;
      if(this.payMode == 0){
        var routerDate = this.$router.resolve({name: 'OrderPay', params:{orderId: this.selectedOrderId}})
        let href = routerDate.href
        window.location.href = href
      }else{
        this.getQrCode(this.selectedOrderId,this.payMode,this.selectedPid)
      }
    },
    saveOrder(val){
      this.selectedPid = val;
      if(val == '116'){
        if(this.orderId116 && !this.paid116){
          this.selectedOrderId = this.orderId116
          this.getOrderStatusTimer(this.orderId116,'116')
          return false;
        }
      }else if( val == '73'){
        if(this.orderId73 && !this.paid73){
          this.selectedOrderId = this.orderId73
          this.getOrderStatusTimer(this.orderId73,'73')
          return false;
        }
      }else{
        this.$global.alert("非法请求");
      }
      var activityParam = {
        productId: val,
        monthCount: 12
      }
      this.$post("/order/activityBuying", activityParam)
            .then(response => {
              if (response.code === 0) {
                var orderId = response.data.id;
                this.selectedOrderId = orderId;
                this.lastInvoiceTitleType = response.data.invoiceTitleType;
                this.invoiceTitleType = response.data.invoiceTitleType;
                if(val == '116'){
                  this.orderId116 = orderId;
                  this.getQrCode(orderId,this.payMode,'116')
                }else if(val == '73'){
                  this.orderId73 = orderId;
                  this.getQrCode(orderId,this.payMode,'73')
                }
                this.getOrderStatusTimer(orderId,val)
              } else if (response.code === 203) {
                this.$global.alert(response.msg);
              }else{
                var params = {
                  productId: val,
                  monthCount: 12,
                  orderType: 0,
                  convertMoney: 0,
                  invoiceTitleType: 1,
                  questionsId: "0",
                  buySource: this.s
                };
                this.$post("/order/save", params)
                  .then(response => {
                    if (response.code === 0) {
                      var orderId = response.data.id;
                      this.selectedOrderId = orderId
                      if(val == '116'){
                        this.orderId116 = orderId;
                        this.getQrCode(orderId,this.payMode,'116')
                      }else if(val == '73'){
                        this.orderId73 = orderId;
                        this.getQrCode(orderId,this.payMode,'73')
                      }
                      this.getOrderStatusTimer(orderId,val)
                    } else {
                      this.$global.alert(response.msg);
                    }
                  })
                  .catch(err => {
                    this.$global.alertError();
                  });
              }
            })
            .catch(err => {
              this.$global.alertError();
            });
    },

    getQrCode(val,val2,val3) {
      if (this.lock) {
        return false;
      }
      var params = {
        id: val,
        payMode: val2
      };
      // if(val3 == '116'){
      //   if (val2 == 29 && this.aliPayQrCode116) {
      //     this.qrData = this.aliPayQrCode116;
      //     return false;
      //   }
      //   if (val2 == 23 && this.wechatPayQrCode116) {
      //     this.qrData = this.wechatPayQrCode116;
      //     return false;
      //   }
      // }else if (val3 == '73'){
      //   if (val2 == 29 && this.aliPayQrCode73) {
      //     this.qrData = this.aliPayQrCode73;
      //     return false;
      //   }
      //   if (val2 == 23 && this.wechatPayQrCode73) {
      //     this.qrData = this.wechatPayQrCode73;
      //     return false;
      //   }
      // }
      this.lock = true;
      this.$get("/pay/qrcode", params)
        .then(response => {
          if (response.code === 0) {
            this.qrData = response.data;
            if(val3 == '116'){
              if (val2 == 29) {
                this.aliPayQrCode116 = this.qrData;
              }
              if (val2 == 23) {
                this.wechatPayQrCode116 = this.qrData;
              }
            }else if (val3 == '73'){
              if (val2 == 29) {
                this.aliPayQrCode73 = this.qrData;
              }
              if (val2 == 23) {
                this.wechatPayQrCode73 = this.qrData;
              }
            }
          }
          this.lock = false;
        })
        .catch(err => {
          this.qrData = '';
          this.lock = false;
        });
    },
    getOrderStatusTimer(val,val2) {
      var count = 60;
      this.timer = setInterval(() => {
        if (count <= 0) {
          clearInterval(this.timer);
        } else {
          count--;
          this.getOrderStatus(val,val2)
          if(this.accomplish == true){
            clearInterval(this.timer)
          }
        }
      }, 2000);
    },
    getOrderStatus(val,val2) {
      if(val !== this.orderId116 && val !== this.orderId73){
        return;
      }
      this.$get("/order/status?id=" + val)
        .then(response => {
          if (response.code === 0 && response.data == 1) {
            this.accomplish = true;
            this.pay = false;
            this.order = false;
            if(val2 === '116'){
              this.paid116 = true;
            }
            if(val2 === '73'){
              this.paid73 = true;
            }
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
    openInvoice() {
      //调用子组件发票抬头类型
      this.$refs.invoice.openInvoice();
    },
    changeInvoiceTitleType(invoiceTitleType) {
      //获取发票组件发票抬头类型
      this.invoiceTitleType = invoiceTitleType;
      if(this.invoiceTitleType !== this.lastInvoiceTitleType){
        this.lastInvoiceTitleType = this.invoiceTitleType;
        this.updatePaymentInvoiceTitleType()
      }
    },
    updatePaymentInvoiceTitleType(){
      this.$get("/order/updateInvoiceTitleType?orderId=" + this.selectedOrderId + "&invoiceTitleType=" + this.invoiceTitleType)
        .then(response => {
          if (response.code !== 0) {
            this.alert(response.msg)
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@keyframes scale-up-center {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
* {
  box-sizing: border-box;
}
.br >>> .el-carousel__arrow {
  box-shadow: 0 0 6px rgba(255, 255, 255, 1);
  background: rgba(31, 45, 61, 0.41);
  width: 60px;
  height: 60px;
  font-size: 25px;
  font-weight: bold;
}
.junActivity2 {
  background: #88071b;
  .header {
    background: url("../../assets/images/activity/junActivity2/05.png")
      no-repeat center top;

    .w933 {
      width: 933px;
      height: 625px;
      margin: 0 auto;

      .discount_coupon {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 10px;
        .left {
          .hand {
            width: 100px;
            height: 100px;
            position: absolute;
            top: 350px;
            left: 270px;
            animation: click-animation 0.9s infinite;
          }
          @keyframes click-animation {
            0%,
            100% {
              transform: scale(1);
            }
            50% {
              transform: scale(0.9);
            }
          }
        }

        .left,
        .right {
          width: 433px;
          height: 204px;
          position: relative;
          .button {
            position: absolute;
            width: 331px;
            height: 43px;
            left: 50%;
            margin-left: -165.5px;
            top: 125px;
            cursor: url("../../assets/images/activity/junActivity2/02.png"),
              auto; /* 注意路径，确保图片路径正确 */
            animation: click-animation 1.2s infinite;
            @keyframes click-animation {
              0%,
              100% {
                transform: scale(1);
              }
              50% {
                transform: scale(0.9);
              }
            }
          }
        }
      }
    }
  }

  .content01 {
    .w933 {
      width: 933px;
      margin: 0 auto;
      .bg {
        height: 731px;
        background: url("../../assets/images/activity/junActivity2/08.png")
          no-repeat center top;
        position: relative;
        .ljqg {
          width: 535px;
          height: 89px;
          position: absolute;
          left: 50%;
          bottom: -70px;
          margin-left: -267.5px;
          cursor: pointer;
          animation: click-animation 1.2s infinite;
          @keyframes click-animation {
            0%,
            100% {
              transform: scale(1);
            }
            50% {
              transform: scale(0.9);
            }
          }
        }

        .agreement {
          color: #fff;
          font-size: 14px;
          width: 535px;
          height: 89px;
          position: absolute;
          left: 50%;
          bottom: -140px;
          margin-left: -267.5px;
          text-align: center;
        }
        .carousel1 {
          border: 1px solid rgba(255, 0, 0, 0);
          .br {
            margin: 95px auto 0;
            width: 901px;
            overflow: hidden;
            height: 609px;
            border-radius: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .content03 {
    .w933 {
      width: 933px;
      margin: 110px auto 0;
      .bg {
        height: 379px;
        background: url("../../assets/images/activity/junActivity2/10.png")
          no-repeat center top;
        position: relative;
      }
    }
  }

  .content04 {
    .w933 {
      width: 933px;
      margin: 30px auto 0;
      .bg {
        height: 874px;
        background: url("../../assets/images/activity/junActivity2/11.png")
          no-repeat center top;
        position: relative;
        .ljqg {
          width: 535px;
          height: 89px;
          position: absolute;
          left: 50%;
          bottom: -60px;
          margin-left: -267.5px;
          cursor: pointer;
          animation: click-animation 1.2s infinite;
          @keyframes click-animation {
            0%,
            100% {
              transform: scale(1);
            }
            50% {
              transform: scale(0.9);
            }
          }
        }

        .agreement {
          color: #fff;
          font-size: 14px;
          width: 535px;
          height: 89px;
          position: absolute;
          left: 50%;
          bottom: -130px;
          margin-left: -267.5px;
          text-align: center;
        }
        .carousel1 {
          border: 1px solid rgba(255, 0, 0, 0);
          .br {
            margin: 100px auto 0;
            width: 900px;
            overflow: hidden;
            height: 739px;
            border-radius: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .content05 {
    .w933 {
      width: 933px;
      margin: 80px auto 0;
      .bg {
        height: 416px;
        background: url("../../assets/images/activity/junActivity2/12.png")
          no-repeat center top;
        position: relative;
      }
    }
  }

  .risk_warning {
    text-align: center;
    color: #fff;
    font-size: 12px;
    padding: 30px 0 50px;
    line-height: 22px;
    opacity: 0.5;
  }
}

.shade_bg {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  z-index: 99;
  .accomplish {
    position: fixed;
    width: 373px;
    height: 400px;
    top: 50%;
    margin-top: -200px;
    left: 50%;
    margin-left: -186.5px;
  }

  .order_bg {
    background: url("../../assets/images/activity/junActivity2/18.png")
      no-repeat center top;
    position: fixed;
    width: 430px;
    height: 244px;
    top: 50%;
    margin-top: -122px;
    left: 50%;
    margin-left: -215px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    .con {
      p {
        &:nth-child(1) {
          font-size: 24px;
          color: #2b2b2b;
          font-weight: 800;
        }
        &:nth-child(2) {
          margin-top: 30px;
        }
        &:nth-child(3) {
          margin-top: 5px;
        }
        &:nth-child(2),
        &:nth-child(3) {
          font-size: 18px;
          color: #d97844;
        }
      }

      .pay_btn {
        margin-top: 30px;
        button {
          border: none;
          width: 165px;
          height: 50px;
          border-radius: 30px;
          font-size: 18px;
          font-weight: 800;
        }
        .close {
          color: #262626;
          margin-right: 30px;
        }
        .goon {
          color: #7c390f;
          background: linear-gradient(to right, #f1bc9e, #fce8d6);
        }
      }
    }
  }

  .pay_bg {
    background: #ffe8b9;
    width: 450px;
    height: 636px;
    position: fixed;
    top: 50%;
    margin-top: -318px;
    left: 50%;
    margin-left: -225px;
    border-radius: 20px;
    .top_con {
      height: 490px;
      padding: 50px 40px;
      text-align: center;
      position: relative;
      &::before {
        background: url("../../assets/images/activity/junActivity2/19.png")
          no-repeat right bottom;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 490px;
        opacity: 0.3;
        z-index: -1;
      }
      .close {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
      .title {
        font-size: 23px;
        color: #4d0819;
        .type {
          font-size: 26px;
          color: #1a1d20;
        }
      }
      .code {
        text-align: center;
        margin-top: 25px;
        margin-left: 55px;
        width: 260px;
        height: 260px;
        background-color: #fff;
      }
      .pay_list {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 30px;
        li {
          position: relative;
          width: 75px;
          height: 75px;
          flex-shrink: 0;
          margin: 0 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &::before {
            position: absolute;
            content: "";
            border-right: 1px solid #e2ab24;
            height: 55px;
            right: -24px;
          }
          &:last-child {
            border: none;
            &::before {
              display: none;
            }
          }
          img {
            width: 20px;
            height: 20px;
            margin-bottom: 10px;
          }
        }
        .payClick {
          background: rgba(255, 255, 255, 0.7);
          border-radius: 10px;
        }
      }
    }
    .btm_con {
      background: #fff;
      border-radius: 20px;
      height: 146px;
      padding: 25px 60px;
      .p1 {
        display: flex;
        align-items: end;
        span {
          margin-right: 10px;
        }
        .span1 {
          font-size: 16px;
          color: #777777;
        }
        .span2 {
          font-size: 16px;
          color: #ad7d54;
        }
        .span3 {
          font-size: 32px;
          color: #ad7d54;
        }
        .span4 {
          font-size: 16px;
          color: #ad7d54;
          text-decoration: line-through;
        }

        .span5 {
          font-size: 12px;
          color: #fff;
          border-radius: 10px 0 10px 0;
          background: linear-gradient(to right, #ffa276, #ff69aa);
          padding: 5px;
        }
      }

      .p2 {
        font-size: 12px;
        color: #777777;
        margin-top: 10px;
        a {
          color: #1997ff;
          margin-left: 10px;
        }
      }

      .p3 {
        font-size: 12px;
        color: #777777;
        margin-top: 10px;
        a {
          color: #1997ff;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/junActivity2.vue